export default __webpack_public_path__ + "static/media/cp_geo_tv.1836b623.svg";